import { useState } from 'react';
import {
    SelectionPanelCheckShape,
    SelectionPanelCheckStyle,
    SelectionPanelGroupComponentSpacing,
    SelectionPanelGroupLayoutStyle,
    SelectionPanelGroupStyleMode,
    SelectionPanelGroupTheme,
    YesNoSelectionPanelGroup,
} from '@apply/components';
import { ConfirmModal } from '@apply/ui';
import { useStandardLoanStore } from '../../../../../../state/standardLoanStore';
import { showsFdilaAgreement } from '../functions/showsFdilaAgreement';

/**
 * "Under a FDILA Agreement?" — only for Outstanding/Repaid loans. Turning it off while terms are entered asks first,
 * since it also clears the terms.
 */
export const FdilaAgreementField = () => {
    const inForbearance = useStandardLoanStore((state) => state.setup.inForbearance);
    const hasTerms = useStandardLoanStore((state) => state.setup.forbearanceAgreementTerms.length > 0);
    const context = useStandardLoanStore((state) => state.setupLoanContext);
    const updateSetup = useStandardLoanStore((state) => state.updateSetup);
    const [isConfirmOpen, set_isConfirmOpen] = useState(false);

    if (!showsFdilaAgreement(context)) {
        return null;
    }

    const handleChange = (value: boolean | undefined) => {
        if (inForbearance && !value && hasTerms) {
            set_isConfirmOpen(true);
            return;
        }
        updateSetup({ inForbearance: !!value });
    };

    return (
        <>
            <YesNoSelectionPanelGroup
                id='setupInForbearance'
                value={inForbearance}
                onChange={handleChange}
                theme={SelectionPanelGroupTheme.Blue}
                styleMode={SelectionPanelGroupStyleMode.Condensed}
                checkShape={SelectionPanelCheckShape.Circle}
                checkStyle={SelectionPanelCheckStyle.Fill}
                label='Under a FDILA Agreement?'
                layoutStyle={SelectionPanelGroupLayoutStyle.Horizontal}
                labelWidth='100px'
                wrapPanels={true}
                componentSpacing={SelectionPanelGroupComponentSpacing.StandardSpacing}
            />
            <ConfirmModal
                isOpen={isConfirmOpen}
                text='Removing this Agreement will also remove the Agreement Terms.'
                confirmCallback={() => {
                    set_isConfirmOpen(false);
                    updateSetup({ inForbearance: false, forbearanceAgreementTerms: '' });
                }}
                cancelCallback={() => set_isConfirmOpen(false)}
                confirmButtonText='Continue'
                cancelButtonText='Cancel'
            />
        </>
    );
};
